export const ROLE_ACCESS_TYPES = {
  LAYOUT: 'layout',
  TEMPLATES: 'templates',
  SCREEN_GROUPS: 'screen-groups',
};
